/*
 * JB SHOP CARD — GLOBAL COMPONENT v1
 * Delegated controls work for initial cards and asynchronously injected recommendations.
 */
(() => {
  if (window.__jbShopCardReady) return;
  window.__jbShopCardReady = true;

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-jb-shop-minus]');
    const plus = event.target.closest('[data-jb-shop-plus]');
    const button = minus || plus;
    if (!button) return;

    const card = button.closest('[data-jb-shop-card]');
    const quantity = button.closest('[data-jb-shop-quantity]');
    const input = quantity && quantity.querySelector('input[name="quantity"]');
    if (!card || !input) return;

    const minimum = Math.max(1, Number(input.min) || 1);
    const current = Math.max(minimum, Number(input.value) || minimum);
    input.value = minus ? Math.max(minimum, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-jb-shop-variant]');
    if (!select) return;

    const card = select.closest('[data-jb-shop-card]');
    const form = select.closest('form');
    const hidden = form && form.querySelector('[data-jb-shop-variant-id]');
    const add = form && form.querySelector('.jb-shop-card__add');
    const label = form && form.querySelector('[data-jb-shop-button-text]');
    const option = select.options[select.selectedIndex];
    if (!card || !hidden || !add || !label || !option) return;

    hidden.value = option.value;
    const available = option.dataset.available === 'true';
    const preorder = card.dataset.jbPreorder === 'true';
    add.disabled = !available;
    add.setAttribute('aria-disabled', available ? 'false' : 'true');
    label.textContent = available ? (preorder ? 'Preorder' : 'Add to Cart') : 'Sold Out';
  });
})();

